import { shipmentApiClient } from '../shipmentApiClient'
import { deleteShipmentVisitEndpoint } from './endpoint'
import type { DeleteShipmentVisitParams, DeleteShipmentVisitRequest } from './type'

export const deleteShipmentVisit = async (params: DeleteShipmentVisitParams): Promise<void> => {
  const body: DeleteShipmentVisitRequest = {
    delivery_report_uid: params.deliveryReportUid,
    driver_phone: params.driverPhone,
  }
  // DELETE は body を data オプションで送る（interceptor の decamelize も data に効く）
  await shipmentApiClient.delete(deleteShipmentVisitEndpoint(params.shipmentUid, params.visitId), {
    data: body,
  })
}
